module.exports = __webpack_public_path__ + "img/online_b.54bf3f76.svg";